import { useParams, useSearchParams } from 'react-router-dom';
import { decrypt } from '../../features/utils/crypto';
import { clone } from '../../features/utils/objClone';
import getFlightOfferPrice from '../../controllers/Flight/getOfferPrice';
import convertFlightObject, { createFlightCat } from '../../features/utils/flight/flightOfferObj';
import getFlightSeats from '../../controllers/Flight/getFlightSeats';
import moment from 'moment';
import { useMemo } from 'react';
import { offerSearchTemp } from '../../data/flight/offerSearchData';
import axios from 'axios';
import getFlightOffers from '../../controllers/Flight/getFlightOffers';
import getMyGDSOffers from '../../controllers/Flight/getMyGDSOffers';

let cancelToken = null;

export default function useOffer() {
    // const {id} = useParams();
    // const qObj = JSON.parse(decrypt(id));
    // const {bookingData} = useSelector(state => state.flightBooking);
      
    async function getPrice({data,qObj}) {
        const offer = [data];
        let offers = ([{segments: [{},{}]}])
        
        const length = Math.min(offer?.length,qObj?.originDestinations?.length || null)
        let flightOffers = clone(offer?.at((length)-1)?.og || offer?.at(length - 1))
        offer?.slice(0,length)?.map((obj,i) => {
          try {
            flightOffers.directions[i] = obj.directions[i];
            // flightOffers.segments[i] = obj.segments[i];
          } catch(ex) {console.log(ex)}
          return true;
        })
        // flightOffers.segments = null;
        // flightOffers.fareRules = null;
    
        // .map(obj => {
        //   let temp = clone(obj);
        //   // temp.directions = [temp.directions[0]]
        //   return temp
        // })
        const req = {
          supplier: flightOffers?.supplier,
          offers: [flightOffers]
        }
        if(qObj?.adjustment)
          req['adjustment'] = qObj?.adjustment;
        
        // setLoading(true);
        const res = await getFlightOfferPrice(req);
        // setLoading(false);
        if(res.return) {
          let data = (res.data.data?.map(obj => ({...convertFlightObject(obj),og:obj})) || [])
          offers = (data)
        //   dispatch(setBookingData({...bookingData,offersPrice: data,time: new Date().getTime()}))
        //   priceDiff = ({
        //     price: data?.at(0)?.totalAmount,
        //     change: data?.at(0)?.totalAmount - beforePrice?.totalAmount || 0
        //   })
        } else offers = (null)

        return {offers};
    }
    
    async function getSeatMap(offer) {
        const modOffer = clone(offer?.og || offer?.orgi || offer);  
        let ancilaries = [];

        const reqData = {
          offers: [modOffer],
          supplier: offer?.supplier
        }
    
        // const arrivalLocation = modOffer?.directions?.flat()?.at(routeIndex)?.arrival?.location;
        // const departureLocation = modOffer?.directions?.flat()?.at(routeIndex)?.departure?.location;
        // setLoading(true);
        const res = await getFlightSeats(reqData);
        // setLoading(false);
        if(res.return) {
          let resData = res?.data?.data || res?.data;
          ancilaries = (Array.isArray(resData) ? resData : [])
          // setData([res.data?.find(obj => obj.arrivalLocation === arrivalLocation && obj.departureLocation === departureLocation)] || []);
          // setSelectedSeat()
        } else ancilaries = ([]);

        return ancilaries;
    
      }

      const [searchParam] = useSearchParams();
      const q = useMemo(() => searchParam.get("q"), [searchParam]);
      const qIndex = searchParam.get("path");

      function getSearchParam({req,prevOffer}) {
        
        if (!q && !test) return { return: false };
        let obj = req || clone(JSON.parse(decrypt(q))) || {};
  
        obj["originDestinations"]?.map((obj) => {
          obj.departure.date = moment(obj.date).format("YYYY-MM-DD");
          obj.from = obj.from?.iata || obj?.from;
          obj.to = obj.to?.iata || obj?.to;
  
          return true;
        });
  
        let path = parseInt(qIndex || 0);
        if (path) {
          if (prevOffer) {
            obj["supplier"] = [prevOffer.supplier];
            obj["flightFilters"] = {
              ...(obj.flightFilters || {}),
              allowedCarriers: [
                prevOffer?.directions?.at(0)?.at(0)?.airline?.marketing,
              ],
            };
          }

        } else {
          obj["supplier"] = offerSearchTemp.supplier;
          obj["flightFilters"] = {
            ...(obj.flightFilters || {}),
          };
        }
  
        return obj;        
      }
      
      async function search({req,prevOffer,onDownloadProgress}) {
        const obj = getSearchParam({req,prevOffer});

        if (cancelToken) cancelToken.cancel("Cancelled for another search");
        cancelToken = axios.CancelToken.source();
        const newRes = await getFlightOffers(obj, null, onDownloadProgress);
        if (newRes.return) {
          let data = newRes?.data?.data?.map((obj) => ({
            ...(convertFlightObject(obj) || {}),
            og: obj,
          }));
          return {
            return: 1,
            msg: "Successfull",
            data,
            cat: createFlightCat(data),
          };
        } else return newRes;
      }

      async function searchMyGDS({req,prevOffer,onDownloadProgress}) {
        const obj = getSearchParam({req,prevOffer});

        if (cancelToken) cancelToken.cancel("Cancelled for another search");
        cancelToken = axios.CancelToken.source();
        const newRes = await getMyGDSOffers(obj, null, onDownloadProgress);
        if (newRes.return) {
          let data = newRes?.data?.data?.map((obj) => ({
            ...(convertFlightObject(obj) || {}),
            og: obj,
          }));
          return {
            return: 1,
            msg: "Successfull",
            data,
            cat: createFlightCat(data),
          };
        } else return newRes;
      }
    
  return {
    search,
    searchMyGDS,
    getPrice,
    getSeatMap,
  }
}
